import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No, el Método Detailing Pro está diseñado desde cero. Te explicamos cada paso de forma sencilla para que puedas aprender incluso si nunca tocaste una pulidora en tu vida.'
  }, {
    q: '¿Necesito herramientas caras para empezar?',
    a: 'No. En el Bono 1 te mostramos exactamente qué herramientas y productos económicos necesitas para empezar a trabajar de forma profesional sin gastar una fortuna.'
  }, {
    q: '¿Cómo accedo al curso?',
    a: 'Una vez realizado el pago de $30.000 ARS, recibirás inmediatamente un correo electrónico con el acceso a todo el material (los 5 tomos y los 3 bonos) para que lo descargues y leas cuando quieras.'
  }, {
    q: '¿El contenido es fácil de entender?',
    a: 'Totalmente. Hemos eliminado todo el vocabulario técnico innecesario. Es una guía práctica, directa al grano y diseñada para que apliques lo aprendido rápidamente.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#0A1628] py-20 px-4" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <div className="text-center mb-12" data-id="element-103">
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-104">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-105">
          {faqs.map((faq, index) => <div key={index} className="border border-[#1E3A5F] rounded-xl overflow-hidden transition-all duration-300" data-id="element-106">
              <button className="w-full px-6 py-5 text-left bg-[#132847] hover:bg-[#1A3358] flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-107">
                <span className="font-bold text-lg text-white pr-4" data-id="element-108">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-[#D4AF37] flex-shrink-0" data-id="element-109" /> : <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-110" />}
              </button>

              <div className={`px-6 bg-[#0E1F3D] overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 py-5 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-111">
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-112">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}